(() => {
  if (window.wadlAtelierBound) return;
  window.wadlAtelierBound = true;
  const menus = () => [...document.querySelectorAll('details.wadl-atelier-menu, .wadl-atelier-intro')];
  const isOpen = item => item.matches('details') ? item.open : item.classList.contains('is-open');
  let hoverTimer;
  let scrollQuietUntil = 0;
  let menuDocumentTop = 0;
  const hoverEnabled = () => window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
  const close = detail => {
    if (detail.matches('details')) detail.open = false;
    else detail.classList.remove('is-open');
    detail.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    if (!menus().some(isOpen)) {
      const header = document.querySelector('.header-wrapper');
      if (header) header.preventHide = false;
    }
  };
  const measure = () => {
    const header = document.querySelector('.header-wrapper');
    if (header) {
      const bottom = header.getBoundingClientRect().bottom;
      menuDocumentTop = bottom + window.scrollY;
      document.documentElement.style.setProperty('--atelier-header-bottom', `${Math.max(0,bottom)}px`);
      document.documentElement.style.setProperty('--atelier-scroll-top', `${bottom}px`);
    }
  };
  const openMenu = detail => {
    menus().filter(item => item !== detail).forEach(close);
    measure();
    if (detail.matches('details')) detail.open = true;
    else detail.classList.add('is-open');
    const header = document.querySelector('.header-wrapper');
    if (header) header.preventHide = true;
  };
  document.addEventListener('toggle', event => {
    if (!event.target.matches('details.wadl-atelier-menu')) return;
    event.target.querySelector('summary')?.setAttribute('aria-expanded', String(event.target.open));
    if (event.target.open) {
      menus().filter(item=>item!==event.target).forEach(close);
      measure();
    }
  }, true);
  // Desktop mouse only: allow a small grace period when moving into the panel.
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse' || !hoverEnabled() || performance.now() < scrollQuietUntil) return;
    const detail = event.target.closest('details.wadl-atelier-menu, .wadl-atelier-intro');
    // Internal span/icon transitions must not cancel a pending open.
    if (!detail || detail.contains(event.relatedTarget)) return;
    clearTimeout(hoverTimer);
    if (isOpen(detail)) return;
    const open = () => openMenu(detail);
    if (menus().some(isOpen)) open();
    else hoverTimer = setTimeout(open, 35);
  });
  document.addEventListener('pointerout', event => {
    if (event.pointerType !== 'mouse' || !hoverEnabled()) return;
    const detail = event.target.closest('details.wadl-atelier-menu, .wadl-atelier-intro');
    if (!detail || detail.contains(event.relatedTarget)) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(() => close(detail), 220);
  });
  document.addEventListener('pointerdown', event => {
    clearTimeout(hoverTimer);
    if (!event.target.closest('.header-wrapper')) menus().forEach(close);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    clearTimeout(hoverTimer);
    const opened = menus().find(isOpen);
    if (opened) { close(opened); opened.querySelector('summary, a')?.focus(); }
  });
  document.addEventListener('focusin', event => {
    const intro = event.target.closest('.wadl-atelier-intro');
    if (intro && window.matchMedia('(min-width: 990px)').matches) { clearTimeout(hoverTimer); openMenu(intro); }
  });
  document.addEventListener('focusout', event => {
    const intro = event.target.closest('.wadl-atelier-intro');
    if (intro && !intro.contains(event.relatedTarget)) close(intro);
  });
  // Keep the panel at the document position of the header instead of pinning it
  // to the viewport. Scrolling remains native, including over the open panel.
  window.addEventListener('scroll', () => {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    clearTimeout(hoverTimer);
    scrollQuietUntil = performance.now() + 120;
    const opened = menus().filter(isOpen);
    if (!opened.length) return;
    const top = menuDocumentTop - window.scrollY;
    document.documentElement.style.setProperty('--atelier-scroll-top', `${top}px`);
    const bottom = Math.max(...opened.map(item =>
      item.querySelector('.mega-menu__content, .wadl-atelier-intro-panel')?.getBoundingClientRect().bottom ?? 0));
    if (bottom <= 0) {
      opened.forEach(close);
      const header = document.querySelector('.header-wrapper');
      if (header) header.preventHide = false;
    }
  }, {passive:true, capture:true});
  window.addEventListener('resize', measure, {passive:true});
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('details.wadl-atelier-menu, .wadl-atelier-intro');
    if (panel) panel.open = true;
  });
})();
